import "jquery";
import "jquery-migrate";

const _jq = (window as any).jQuery;
if (_jq) {
  _jq.migrateMute = true;
  _jq.migrateTrace = false;
}

import "@angular/forms";
import "bootstrap/dist/css/bootstrap.css";
//import 'font-awesome/css/font-awesome.min.css';
import "typeface-roboto/index.css";

import "../Kendo/2020.2.617/styles/kendo.common-material.min.css";
import "../Kendo/2020.2.617/styles/kendo.default.mobile.min.css";
import "./insa-report/web/viewer.css";

import "../pv_defaults.json";
import "./insa-pivot/style/pivotviewer.css";
import "./insa-pivot/lib/leaflet/leaflet.css";

// var Timeline_ajax_url="app/html5pivot/lib/simile-timeline/timeline_ajax/simile-ajax-api.js";
// var Timeline_urlPrefix='app/html5pivot/lib/simile-timeline/timeline_js/';
// var Timeline_parameters='bundle=true';

// import './html5pivot/lib/simile-timeline/timeline_js/timeline-api.js';
// wicket is not used!
// import './html5pivot/lib/wicket/wicket.min.js';

import "./insa-pivot/lib/jquery-ui/jquery-ui-1.10.4.custom.min.js";
import "../insa-css/font-awesome.js";

import "./insa-pivot/lib/easing/easing.js";
import "./insa-pivot/lib/jquery.mousewheel/jquery.mousewheel.min.js";
import "./insa-pivot/lib/jquery.tooltipster/jquery.tooltipster.min.js";
import "./insa-pivot/lib/colResizable/colResizable-1.3.min.js";
import "./insa-pivot/lib/purl-master/purl.js";
import "./insa-pivot/lib/leaflet/leaflet-0.6.4.js";
import "./insa-pivot/pivot_loader";
import "./insa-pivot/pivotviewer.min.js";

import "lodash.clonedeep";

//import * as $ from '../Kendo/2020.2.617/js/jquery.min.js';
import * as $ from "jquery";
// we need to import these properties file for localizations of PDFJS
import "./insa-report/web/locale/locale.properties";
import "./insa-report/web/locale/en-US/viewer.properties";
import "./insa-report/web/locale/en-GB/viewer.properties";
import "./insa-report/web/locale/de/viewer.properties";
import "./insa-report/web/locale/hr/viewer.properties";
import "./insa-report/web/l10n.js";

import "core-js"; ////client/shim.min.js'
import "../Kendo/2020.2.617/js/kendo.custom.min.js";

import * as JSZip from "jszip";
window["JSZip"] = JSZip;

import "bootstrap";

import "zone.js";
import "reflect-metadata";
// import 'systemjs';
// import '../systemjs.config.js';

// window['System'].import('app').catch(function(err) {
//     console.error(err);
// });

import "./insa-report/web/compatibility.js";
// import './report/build/pdf.js';
var pdfjsLib = require("./insa-report/build/pdf.js");
window["pdfjsLib"] = pdfjsLib;
pdfjsLib.PDFJS.workerSrc = "./workers/pdf.worker.js";
window["workerSrc"] = pdfjsLib.PDFJS.workerSrc;
import "./insa-report/web/viewer.js";

// // Angular
import "@angular/platform-browser";
import "@angular/platform-browser-dynamic";
import "@angular/core";
import "@angular/common";
//import '@angular/http';
import "@angular/common/http";
import "@angular/router";

// // RxJS
import "rxjs";

// IFrame API
import * as JitsiIframeAPI from "../jitsi/external_api.min.js";
window["JitsiIframeAPI"] = JitsiIframeAPI;

$(".wrapper").css("width", window.innerWidth);

import { customGroupHeader } from "./insa-custom-scripts/customGroup-header.module";

customGroupHeader.extendArray();

window["getGroupInfo"] = customGroupHeader.getGroupInfo;
window["getKendoGrid"] = customGroupHeader.getKendoGrid;
window["getGroupCount"] = customGroupHeader.getGroupCount;
window["gridColumnReorder"] = customGroupHeader.gridColumnReorder;
window["KendoGridDataBound"] = customGroupHeader.KendoGridDataBound;



// WEBPACK FOOTER //
// ./app/vendor.ts